"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionStatusIcon = exports.ListMenuStyle = exports.ColumnDetailsDialogWithPermissions = exports.ColumnDetailsDialogGetPermissions = exports.ColumnActionsMenu = void 0;
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const data_structures_1 = require("@tableau/data-structures");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const RemoteTypeIcon_1 = require("../datagrid/cellFormatters/RemoteTypeIcon");
const LabelsHookHelper_1 = require("../Labels/LabelsHookHelper");
const ReRenderPlacePageContext_1 = require("../placePage/ReRenderPlacePageContext");
const LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
const ColumnAndFieldDetailsStyles_1 = require("../style/ColumnAndFieldDetailsStyles");
const ColumnDetailsHooks_1 = require("./ColumnDetailsHooks");
const ColumnFieldsQueryGrid_1 = require("./ColumnFieldsQueryGrid");
const ColumnFlowsQueryGrid_1 = require("./ColumnFlowsQueryGrid");
const ColumnInlineDescriptionEditor_1 = require("./ColumnInlineDescriptionEditor");
const ColumnInlineTagEditor_1 = require("./ColumnInlineTagEditor");
const ColumnActions_1 = require("./types/ColumnActions");
const inlineTestId = 'column-inline-actions';
const selectionTestId = 'column-selection-actions';
exports.ColumnActionsMenu = Object.freeze({
    Inline,
    Selection,
});
function ColumnLabels({ columnId, category, onClose: onCloseProps, canUpdateTable }) {
    var _a, _b;
    const { data } = useColumnDetailsQuery({ columnId });
    const { rerender } = react_1.default.useContext(ReRenderPlacePageContext_1.ReRenderPlacePageContext);
    const onClose = react_1.default.useCallback(() => {
        onCloseProps();
        rerender();
    }, [onCloseProps, rerender]);
    const column = (_a = data === null || data === void 0 ? void 0 : data.columns) === null || _a === void 0 ? void 0 : _a[0];
    if (!column) {
        return null;
    }
    const contentItem = {
        contentId: column.luid,
        contentName: (_b = column.name) !== null && _b !== void 0 ? _b : '',
        contentType: 'column',
        contentIcon: react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: column.remoteType }),
    };
    return (react_1.default.createElement(data_catalog_shared_1.LabelsDialog, { contentItem: contentItem, initialCategory: category === null || category === void 0 ? void 0 : category.toUpperCase(), hideDialog: onClose, capabilities: {
            certification: canUpdateTable,
            warning: canUpdateTable,
        } }));
}
function Inline(props) {
    const [buttonEl, setButtonEl] = react_1.default.useState(null);
    const { state, menuItemInfos, onClick, onSelect, close, dispatch } = useColumnActionsMenu(props);
    if (!props.columnId) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, title: catalog_messages_1.Messages.Actions(), testId: inlineTestId, getContent: (s) => react_1.default.createElement(ActionStatusIcon, { hover: s.hover || s.active || false }), buttonRef: setButtonEl, onClick: onClick, style: ColumnAndFieldDetailsStyles_1.inlineActionsMenuButtonStyle, disabled: !props.canUpdateTable, tabIndex: -1 }),
        state.showing === 'menu' && (react_1.default.createElement(widgets_1.FlyoutListMenuWidget, { anchorEl: buttonEl, menuItemInfos: menuItemInfos, testId: inlineTestId, toggleEl: buttonEl, menuStyle: exports.ListMenuStyle, onSelect: onSelect, requestCloseAll: () => dispatch({ kind: 'HIDE_MENU' }) })),
        state.showing === 'details' && react_1.default.createElement(ColumnDetailsDialogWithPermissions, Object.assign({}, props, { onClose: close, initial: state })),
        state.showing === 'labels' && (react_1.default.createElement(ColumnLabels, { canUpdateTable: props.canUpdateTable, columnId: props.columnId, onClose: close, category: state.category }))));
}
function Selection(props) {
    const { onSelect, close, state, menuItemInfos } = useColumnActionsMenu(props);
    if (!props.columnId) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(widgets_1.HierarchicalDropdownWidget, { type: widgets_1.DropdownButtonType.Line, label: '', menuItemInfos: menuItemInfos, testId: selectionTestId, onSelect: onSelect, style: ColumnAndFieldDetailsStyles_1.columnActionsMenuStyle }, catalog_messages_1.Messages.Actions()),
        state.showing === 'details' && react_1.default.createElement(ColumnDetailsDialogWithPermissions, Object.assign({}, props, { onClose: close })),
        state.showing === 'labels' && (react_1.default.createElement(ColumnLabels, { columnId: props.columnId, onClose: close, category: state.category, canUpdateTable: props.canUpdateTable }))));
}
function reducer(state, action) {
    switch (action.kind) {
        case 'HIDE_MENU':
            return state.showing === 'menu' ? { showing: 'none' } : state;
        case 'CLOSE':
            return { showing: 'none' };
        case 'TOGGLE_MENU':
            return state.showing === 'menu' ? { showing: 'none' } : { showing: 'menu' };
        case 'LAUNCH_LABELS':
            return { showing: 'labels', category: action.category };
        case 'LAUNCH_DETAILS':
            return {
                showing: 'details',
                action: action.value,
            };
    }
}
function useColumnActionsMenu(_a) {
    var _b, _c;
    var { onClose: onCloseParams, columnLuid } = _a, params = tslib_1.__rest(_a, ["onClose", "columnLuid"]);
    const { data } = useColumnDetailsQuery({ columnId: params.columnId, skip: !!columnLuid });
    const [state, dispatch] = react_1.default.useReducer(reducer, (_b = params.initial) !== null && _b !== void 0 ? _b : { showing: 'none' });
    const menuItemInfos = (0, ColumnDetailsHooks_1.useColumnActionItems)(Object.assign(Object.assign({}, params), { columnLuid: (_c = data === null || data === void 0 ? void 0 : data.columns[0].luid) !== null && _c !== void 0 ? _c : columnLuid }));
    const onSelect = react_1.default.useCallback((value) => {
        switch (value) {
            case ColumnActions_1.ColumnActions.Description:
                return dispatch({ kind: 'LAUNCH_DETAILS', value });
            case ColumnActions_1.ColumnActions.Tag:
                return dispatch({ kind: 'LAUNCH_DETAILS', value });
            case ColumnActions_1.ColumnActions.QualityWarning:
                return dispatch({ kind: 'LAUNCH_LABELS', category: 'warning' });
            case ColumnActions_1.ColumnActions.SensitiveLabels:
                return dispatch({ kind: 'LAUNCH_LABELS', category: 'sensitivity' });
            case ColumnActions_1.ColumnActions.CustomLabels:
                return dispatch({ kind: 'LAUNCH_LABELS', category: undefined });
            default:
                return;
        }
    }, [dispatch]);
    const onClick = react_1.default.useCallback(() => dispatch({ kind: 'TOGGLE_MENU' }), [dispatch]);
    const close = react_1.default.useCallback(() => {
        dispatch({ kind: 'CLOSE' });
        if (onCloseParams) {
            onCloseParams();
        }
    }, [onCloseParams, dispatch]);
    return { state, menuItemInfos, onSelect, onClick, close, dispatch };
}
function extractTableLuid(column) {
    var _a;
    if (((_a = column === null || column === void 0 ? void 0 : column.table) === null || _a === void 0 ? void 0 : _a.__typename) === 'DatabaseTable') {
        return column.table.luid;
    }
    return null;
}
function useColumnDetailsQuery(params) {
    return (0, client_1.useQuery)(catalog_queries_1.ColumnDetailsDocument, {
        variables: { columnId: params.columnId },
        skip: !params.columnId || params.skip,
    });
}
function ColumnDetailsDialogGetPermissions(props) {
    const canUpdateTable = (0, ColumnDetailsHooks_1.useCanUserSetColumnDescription)(props.tableVizportalId);
    return react_1.default.createElement(ColumnDetailsDialogWithPermissions, Object.assign({}, props, { canUpdateTable: canUpdateTable }));
}
exports.ColumnDetailsDialogGetPermissions = ColumnDetailsDialogGetPermissions;
function ColumnDetailsDialogWithPermissions(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { data } = useColumnDetailsQuery(props);
    const [buttonEl, setButtonEl] = react_1.default.useState(null);
    const column = (_a = data === null || data === void 0 ? void 0 : data.columns) === null || _a === void 0 ? void 0 : _a[0];
    const { state, menuItemInfos, onClick, close, dispatch } = useColumnActionsMenu(Object.assign(Object.assign({}, props), { columnLuid: (_b = column === null || column === void 0 ? void 0 : column.luid) !== null && _b !== void 0 ? _b : props.columnLuid }));
    const { element: descriptionEditor, startEditing: editDescription } = (0, ColumnInlineDescriptionEditor_1.useColumnInlineDescriptionEditor)({
        canEditDescription: props.canUpdateTable,
        columnLuid: (_c = column === null || column === void 0 ? void 0 : column.luid) !== null && _c !== void 0 ? _c : null,
        columnTableLuid: extractTableLuid(column),
        description: (column === null || column === void 0 ? void 0 : column.description) || '',
        afterDescriptionChange: close,
    });
    const { element: tagEditor, startEditing: editTags } = (0, ColumnInlineTagEditor_1.useColumnInlineTagEditor)({
        canEditTags: props.canUpdateTable,
        columnLuid: (_d = column === null || column === void 0 ? void 0 : column.luid) !== null && _d !== void 0 ? _d : null,
        tags: (0, data_structures_1.removeNulls)((_e = column === null || column === void 0 ? void 0 : column.tags.map((tag) => tag.name)) !== null && _e !== void 0 ? _e : []),
        onUpdate: close,
        viewOnly: true,
    });
    const initial = props.initial;
    const once = react_1.default.useRef(true);
    react_1.default.useEffect(() => {
        let current = true;
        if (current && once.current && (initial === null || initial === void 0 ? void 0 : initial.showing) === 'details') {
            once.current = false;
            if (initial.action === ColumnActions_1.ColumnActions.Description) {
                editDescription();
            }
            if (initial.action === ColumnActions_1.ColumnActions.Tag) {
                editTags();
            }
        }
        return () => {
            current = false;
        };
    }, [editDescription, editTags, initial]);
    const onSelect = react_1.default.useCallback((value) => {
        switch (value) {
            case ColumnActions_1.ColumnActions.Description:
                return editDescription();
            case ColumnActions_1.ColumnActions.Tag:
                return editTags();
            case ColumnActions_1.ColumnActions.QualityWarning:
                return dispatch({ kind: 'LAUNCH_LABELS', category: 'warning' });
            case ColumnActions_1.ColumnActions.SensitiveLabels:
                return dispatch({ kind: 'LAUNCH_LABELS', category: 'sensitivity' });
            case ColumnActions_1.ColumnActions.CustomLabels:
                return dispatch({ kind: 'LAUNCH_LABELS', category: undefined });
            default:
                return;
        }
    }, [dispatch, editDescription, editTags]);
    if (!column) {
        return null;
    }
    const fieldsCount = (_g = (_f = column === null || column === void 0 ? void 0 : column.referencedByFieldsConnection) === null || _f === void 0 ? void 0 : _f.totalCount) !== null && _g !== void 0 ? _g : null;
    const flowsCount = (_j = (_h = column === null || column === void 0 ? void 0 : column.referencedByFlowColumnInputFieldConnection) === null || _h === void 0 ? void 0 : _h.totalCount) !== null && _j !== void 0 ? _j : null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(widgets_1.DialogWidget, { testId: 'column-details', title: catalog_messages_1.Messages.ColumnDetails(), type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered, showCloseButton: true, showFooter: false, isModal: true, onCloseRequest: close, handleGlassClick: close, dialogWidth: 600 },
            react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsPane, null,
                react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ActionMenuProperties, null,
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, title: catalog_messages_1.Messages.Actions(), testId: 'column-inline', getContent: (s) => react_1.default.createElement(ActionStatusIcon, { hover: s.hover || s.active || false }), buttonRef: setButtonEl, onClick: onClick, style: ColumnAndFieldDetailsStyles_1.inlineActionsMenuButtonStyle, disabled: !props.canUpdateTable, tabIndex: -1 }),
                        state.showing === 'menu' && (react_1.default.createElement(widgets_1.FlyoutListMenuWidget, { anchorEl: buttonEl, menuItemInfos: menuItemInfos, testId: 'column-inline', toggleEl: buttonEl, menuStyle: exports.ListMenuStyle, onSelect: onSelect, requestCloseAll: () => dispatch({ kind: 'HIDE_MENU' }) })),
                        state.showing === 'labels' && (react_1.default.createElement(ColumnLabels, { canUpdateTable: props.canUpdateTable, columnId: props.columnId, onClose: close, category: state.category })))),
                react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsColumnName, null, column.name),
                react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsTypeRow, null,
                    react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: column.remoteType }),
                    data_catalog_shared_1.RemoteTypeMappings[column.remoteType]()),
                react_1.default.createElement(LabelsHookHelper_1.LabelWrapper, { itemInfo: column, isEager: true, kind: 'chip', wrapper: (e) => react_1.default.createElement("span", { style: ColumnAndFieldDetailsStyles_1.columnAndFieldDetailsLabelsStyle }, e) }),
                react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsProperties, null,
                    descriptionEditor,
                    tagEditor,
                    react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsProperty, null,
                        react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, catalog_messages_1.Messages.UsedByFields()),
                        react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnFieldsWrapper, { style: {
                                height: (0, LinksDisplayGrid_1.getRowHeight)(fieldsCount, ColumnAndFieldDetailsStyles_1.columnFieldsWrapperMaxRows),
                            } },
                            react_1.default.createElement(ColumnFieldsQueryGrid_1.ColumnFieldsQueryGrid, { columnId: props.columnId, rowCount: fieldsCount }))),
                    react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsProperty, null,
                        react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, catalog_messages_1.Messages.UsedByFlows()),
                        react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnFieldsWrapper, { style: {
                                height: (0, LinksDisplayGrid_1.getRowHeight)(flowsCount, ColumnAndFieldDetailsStyles_1.columnFieldsWrapperMaxRows),
                            } },
                            react_1.default.createElement(ColumnFlowsQueryGrid_1.ColumnFlowsQueryGrid, { columnId: props.columnId, rowCount: flowsCount }))))))));
}
exports.ColumnDetailsDialogWithPermissions = ColumnDetailsDialogWithPermissions;
exports.ListMenuStyle = {
    fontWeight: 'normal',
    top: '-1px',
};
function ActionStatusIcon(props) {
    return props.hover ? react_1.default.createElement(catalog_icons_1.SvgActionsActive, null) : react_1.default.createElement(catalog_icons_1.SvgActions, null);
}
exports.ActionStatusIcon = ActionStatusIcon;
//# sourceMappingURL=ColumnActionsMenu.js.map